const AZ = AZ || {};

AZ.launcher = (() => {
    const init = () => {
        AZ.cookiebar.init();
        AZ.header.init();
        AZ.masonry.init();
        AZ.languageToggle.init();
        AZ.toggle.init();
        AZ.toggleMenu.init();
        AZ.toggleSearch.init();
        AZ.gallery.init();
        AZ.map.init();
        AZ.counter.init();
        AZ.marketoForm.init();
    }

    return {
        init: init,
    };

})();

window.addEventListener('load', () => {
    'use strict';
    AZ.launcher.init();
});

AZ.cookiebar = (() => {
    const bar = $('.cookiebar');

    const init = () => {
        if (bar.length === 0) {
            return;
        }

        if (hasChosen()) {
            completelyHideBar();
        } else {
            bar.find('#agree').on('click', (e) => {
                e.preventDefault();
                AZ.cookiebar.setChoice(true);
                return false;
            });

            bar.find('#disagree').on('click', (e) => {
                e.preventDefault();
                AZ.cookiebar.setChoice(false);
                return false;
            });

            showBar();
        }
    };

    const setChoice = (choice) => {
        const value = choice ? 'yes' : 'no';
        const expires = new Date(new Date().getTime() + (30 * 864e+5)).toUTCString(); // 30 days
        document.cookie = 'afvalzorg_cookies=' + value + '; expires=' + expires + '; domain=.afvalzorg.es; path=/; Secure; SameSite=None';

        hideBar();
    };

    const hasChosen = () => {
        const value = document.cookie.replace(/(?:(?:^|.*;\s*)afvalzorg_cookies\s*=\s*([^;]*).*$)|^.*$/, '$1');
        return value === 'yes' || value === 'no';
    }

    const showBar = () => bar.addClass('is-active');

    const hideBar = () => bar.removeClass('is-active');

    const completelyHideBar = () => bar.addClass('is-hidden');

    return {
        init: init,
        setChoice: setChoice,
    };
})();

AZ.counter = (() => {
    const init = () => {
        // setup intersection observer
        const intersectionObserver = new IntersectionObserver((entries, self) => {
            handleIntersect(entries, self);
        },{
            threshold: 1,
        });

        const counters = $('[data-counter]');

        counters.each((_index, element) => {
            const counter = element;

            // init started = false
            $(counter).data('has-started', false);

            // observe each counter
            intersectionObserver.observe(counter);
        });
    };

    const startCounter = ($counter) => {
        const value = parseFloat($counter.data('counter'));
        const steps = parseInt($counter.data('steps'));
        const decimalIndex = value.toString().indexOf('.');
        const decimalAmount =
            decimalIndex > 0
                ? value.toString().slice(decimalIndex + 1).length
                : 0;
        const step = value / steps;

        // set started boolean so animation does not start again on another intersect
        $counter.data('has-started', true);

        let newValue = step;
        const interval = window.setInterval(() => {
            // if new value out or range: newValue = value + stop interval
            if (
                (value > 0 && newValue >= value) ||
                (value < 0 && newValue <= value)
            ) {
                newValue = value;
                $counter.html(newValue.toFixed(decimalAmount).toString().replace('.', ','));
                clearInterval(interval);
            } else {
                $counter.html(newValue.toFixed(decimalAmount).toString().replace('.', ','));
                newValue = newValue + step;
            }
        }, 70);
    };

    const handleIntersect = (entries, _self) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // only start if has not started yet
                const counter = $(entry.target);
                if (!counter.data('has-started')) {
                    startCounter(counter);
                }
            }
        });
    };

    return {
        init: init,
    };
})();

AZ.gallery = (() => {
    const init = () => {
        const galleries = $('.gallery');

        galleries.each((_index, element) => {
            const gallery = $(element);
            const carousel = gallery.find('.gallery__carousel');
            const autoPlay = gallery.data('autoplay') === true;

            // Init carousel
            carousel.addClass('owl-carousel');
            carousel.owlCarousel({
                nav: true,
                navContainer: 'gallery__navigation',
                navContainerClass: 'gallery__navigation',
                loop: true,
                mouseDrag: true,
                autoHeight: true,
                autoplay: autoPlay,
                autoplayTimeout: 5000,
                dots: false,
                slideSpeed: 600,
                paginationSpeed: 400,
                singleItem: true,
                items: 1,
            });

            // Init next/prev navigation
            gallery.find('.gallery__next').on('click', (e) => {
                e.preventDefault();
                carousel.trigger('next.owl.carousel');
                return false;
            });

            gallery.find('.gallery__prev').on('click', (e) => {
                e.preventDefault();
                carousel.trigger('prev.owl.carousel');
                return false;
            });

            if (autoPlay) {
                gallery.on('prev.owl.carousel next.owl.carousel', () => {
                    window.requestAnimationFrame(() => {
                        gallery.addClass('gallery--reset');

                        window.requestAnimationFrame(() => {
                            gallery.removeClass('gallery--reset');
                        });
                    });
                });
            }
        });
    };

    return {
        init: init,
    };
})();

AZ.header = (() => {
    const header = $('.header');
    const logoMain = $('.logo--main');
    const logoSticky = $('.logo--sticky');
    const subNav = $('.nav-sub');

    const scrollTop = $(window).scrollTop();
    const scrollPoint = 600;
    const delta = 5;
    let lastScrollTop = 0;
    let didScroll;
    let headerOffset;
    let subNavOffset;

    const init = () => {
        if (header.length === 0) {
            return;
        } else {
            headerOffset = header.innerHeight() + header.offset().top;
        }

        if (subNav.length > 0) {
            subNavOffset = subNav.innerHeight() + subNav.offset().top;
        }

        // Check if header needs to be switch
        AZ.header.switchHeader(scrollTop);

        $(window).on('scroll', () => {
            didScroll = true;
        });

        // reduce the set of functions being run for every pixel scrolled
        setInterval(() => {
            if (didScroll) {
                AZ.header.hasScrolled();
                didScroll = false;
            }
        }, 250);
    }

    const hasScrolled = () => {
        const scrollTop = $(window).scrollTop();

        // Check if header needs to be switch
        AZ.header.switchHeader(scrollTop);

        // Switch classes on scroll
        AZ.header.contentScroll(scrollTop);

        lastScrollTop = scrollTop;
    }

    const switchHeader = (scrollTop) => {
        if (scrollTop > headerOffset) {
            header.addClass('header--sticky');
            logoMain.hide();
            logoSticky.show();

            if (subNav.length > 0) {
                subNav.addClass('is-sticky');
            }
        } else {
            header.removeClass('header--sticky is-shown is-hidden');
            logoMain.show();
            logoSticky.hide();

            if (subNav.length > 0) {
                subNav.removeClass('is-sticky is-shown is-hidden');
            }
        }

        if (subNav.length > 0) {
            if (scrollTop > subNavOffset) {
                subNav.addClass('is-sticky');
            } else {
                subNav.removeClass('is-sticky is-shown is-hidden');
            }
        }
    }

    const contentScroll = (scrollTop) => {
        // Make sure the user scroll more than delta value
        if (Math.abs(lastScrollTop - scrollTop) <= delta) return;

        // Scroll up
        if (scrollTop > lastScrollTop && scrollTop > scrollPoint) {
            header.removeClass('is-shown').addClass('is-hidden');
            if (subNav.length > 0) {
                subNav.removeClass('is-shown').addClass('is-hidden');
            }
        } else {
            // Scroll down
            if (scrollTop > scrollPoint && header.hasClass('header--sticky')) {
                // Scroll past the main site-header
                header.removeClass('is-hidden').addClass('is-shown');
            }
            if (
                subNav.length > 0 &&
                scrollTop > scrollPoint &&
                subNav.hasClass('is-sticky')
            ) {
                // Scroll past the main site-header
                subNav.removeClass('is-hidden').addClass('is-shown');
            }
        }
    }

    return {
        init: init,
        hasScrolled: hasScrolled,
        switchHeader: switchHeader,
        contentScroll: contentScroll,
    };
})();

AZ.languageToggle = (() => {
    function init() {
        const toggle = $('[data-language-toggle]');

        toggle.on('click', (e) => {
            const element = $(e.currentTarget);
            let toggleClass = '' + element.data('language-toggle');
            let toggleTarget = element.data('language-toggle-target');
            document.addEventListener('keydown', closeMenu);

            // Check toggleClass
            if (!toggleClass || 0 === toggleClass.length) {
                toggleClass = 'is-active';
            }

            // Check toggleTarget
            if (!toggleTarget || 0 === toggleTarget.length) {
                toggleTarget = $(this);
            } else {
                toggleTarget = $(toggleTarget);
            }

            // Toggle it!
            if (toggleTarget.length > 0) {
                if (toggleTarget.hasClass(toggleClass)) {
                    toggleTarget.removeClass(toggleClass);
                } else {
                    toggleTarget.addClass(toggleClass);
                }
            }

            // Close menu with Escape
            const closeMenu = (e) => {
                if (e.code === 'Escape') {
                    if (toggleTarget.length > 0) {
                        if (toggleTarget.hasClass(toggleClass)) {
                            toggleTarget.removeClass(toggleClass);
                            document.removeEventListener('keydown', closeMenu);
                        }
                    }
                }
            };

            return false;
        });
    }

    return {
        init: init,
    };
})();

AZ.map = (() => {
    const init = () => {
        const maps = $('.map');
        maps.each((_index, element) => {
            const map = createMapObject(element);

            // Handle categories
            map.categories.on('click', (e) => {
                e.preventDefault();
                const newCategory = $(e.currentTarget).data('map-cat');
                map.setActiveCategory(newCategory);
                return false;
            });

            // Handle overlay
            map.overlay.find('.map-overlay__close').on('click', (e) => {
                e.preventDefault();
                map.hideActiveInfo();
                return false;
            });

            // Handle pins
            map.pins.on('mouseover', (e) => {
                e.preventDefault();
                const pin = $(e.currentTarget);

                if (!map.currPin) {
                    map.setActiveInfo(pin);
                } else if (map.currPin != pin) {
                    map.hideActiveInfo();

                    setTimeout(() => {
                        map.setActiveInfo(pin);
                    }, 200);
                }

                return false;
            });
        });
    };

    const createMapObject = (element) => {
        const map = $(element);
        const pins = map.find('.map__pin');
        const overlay = map.find('.map__overlay');
        const categories = map.find('.map__category');

        return {
            element: map,
            pins: pins,
            overlay: overlay,
            categories: categories,
            currCategory: map.data('map-cat'),
            currPin: false,

            setActiveCategory: function(category) {
                this.hideActiveInfo();
                map.removeClass('map--' + this.currCategory);
                map.addClass('map--' + category);
                this.currCategory = category;
            },

            setActiveInfo: function(pin) {
                // Remove active pin first
                pins.removeClass('is-active');

                // Set active pin
                this.currPin = $(pin);
                this.currPin.addClass('is-active');

                // If allowed set active overlay
                const json = this.currPin.data('map-info'); // jQuery parses this already
                if (json.show_info && json.show_info === 'yes') {
                    this.overlay.find('.map-overlay__name').text(json.name);
                    this.overlay.find('.map-overlay__city').text(json.city);
                    let html = json.text;

                    if (json.image) {
                        html += `<img src="${json.image}" alt="${json.name}">`;
                    }
                    this.overlay.find('.map-overlay__content').html(html);

                    const button = this.overlay.find('.map-overlay__button');
                    if (json.url && json.url.length > 0) {
                        button.attr('href', json.url);
                        button.removeClass('is-hidden');
                    } else {
                        button.addClass('is-hidden');
                    }

                    const elementCenter =
                        this.element.offset().top +
                        this.element.innerHeight() / 2;
                    const pinPosition = this.currPin.offset().top;

                    if (pinPosition > elementCenter) {
                        this.overlay.addClass('map__overlay--bottom');
                    } else {
                        this.overlay.removeClass('map__overlay--bottom');
                    }

                    this.overlay.addClass('is-active');
                }
            },

            hideActiveInfo: function() {
                if (this.currPin) {
                    this.overlay.removeClass('is-active');
                    this.currPin.removeClass('is-active');
                    this.currPin = false;
                }
            },
        };
    };

    return {
        init: init,
    };
})();

AZ.marketoForm = (() => {
    const init = () => {
        AZ.marketoForm.loadMktoScript();
        const forms = $('[data-marketo-form]');

        forms.each((_index, element) => {
            const id = $(element).data('marketo-form');

            // wait until script is loaded
            let timesRun = 0;
            const interval = window.setInterval(() => {
                if (typeof MktoForms2 !== 'undefined') {
                    AZ.marketoForm.loadForm(id);
                    clearInterval(interval);
                }
                timesRun++;
                if (timesRun > 20) {
                    clearInterval(interval);
                }
            }, 200);
        });
    };

    const loadForm = (id) => {
        MktoForms2.loadForm('https://connect.hvcgroep.nl', '944-ZXB-764', id);

        MktoForms2.whenReady((form) => {
            const formElem = form.getFormElem();
            const parent = formElem.closest('[data-marketo-form');

            form.onSuccess((_values, _followUpUrl) => {
                parent.addClass('has-success');
                return false;
            });
        });
    };

    const loadMktoScript = () => {
        if (!$('script[src="https://connect.hvcgroep.nl/js/forms2/js/forms2.min.js"]').length) {
            const tag = document.createElement('script');
            tag.src = 'https://connect.hvcgroep.nl/js/forms2/js/forms2.min.js';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    };

    return {
        init: init,
        loadMktoScript: loadMktoScript,
        loadForm: loadForm,
    };
})();

AZ.masonry = (() => {
    const init = () => {
        if ($('.teaser-masonry').length > 0) {
            Macy({
                container: '.teaser-masonry',
                waitForImages: false,
                margin: 20,
                columns: 3,
                breakAt: {
                    1024: 2,
                    768: 1,
                },
            });
        }
    };

    return {
        init: init,
    };
})();

AZ.toggleMenu = (() => {
    const siteWrapper = $('.site');

    const init = () => {
        enquire.register('screen and (max-width:1024px)', {
            unmatch: () => {
                siteWrapper.removeClass('site--mobile');
            },
        });
    };

    return {
        init: init,
    };
})();

AZ.toggleSearch = (() => {
    const drawer = $('.drawer--search');

    const init = () => {
        if (drawer.length == 0) {
            return;
        }

        $('.nav__item--search').on('click', (e) => {
            e.preventDefault();
            AZ.toggleSearch.open();
            return false;
        });

        drawer.find('.drawer__close').on('click', (e) => {
            e.preventDefault();
            AZ.toggleSearch.close();
            return false;
        });
    };

    const open = () => {
        window.requestAnimationFrame(() => {
            drawer.addClass('is-active');

            window.requestAnimationFrame(() => {
                drawer.find('.search-form__input').focus();
                drawer.addClass('is-open');
            });
        });
    };

    const close = () => {
        drawer.removeClass('is-open');

        setTimeout(() => {
            drawer.removeClass('is-active');
        }, 250);
    };

    return {
        init: init,
        open: open,
        close: close,
    };
})();

AZ.toggle = (() => {
    function init() {
        const toggle = $('[data-toggle]');

        toggle.on('click', (e) => {
            e.preventDefault();

            const element = $(e.currentTarget);
            let toggleClass = '' + element.data('toggle');
            let toggleTarget = element.data('toggle-target');

            // Check toggleClass
            if (!toggleClass || 0 === toggleClass.length) {
                toggleClass = 'is-active';
            }

            // Check toggleTarget
            if (!toggleTarget || 0 === toggleTarget.length) {
                toggleTarget = $(this);
            } else {
                toggleTarget = $(toggleTarget);
            }

            // Toggle it!
            if (toggleTarget.length > 0) {
                if (toggleTarget.hasClass(toggleClass)) {
                    toggleTarget.removeClass(toggleClass);
                } else {
                    toggleTarget.addClass(toggleClass);
                }
            }

            return false;
        });
    }

    return {
        init: init,
    };
})();
